import { render } from "./HospitalMarketers.vue?vue&type=template&id=97335556"
import script from "./HospitalMarketers.vue?vue&type=script&lang=js"
export * from "./HospitalMarketers.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/marketers/HospitalMarketers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97335556"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97335556', __exports__)) {
    console.log('reload')
    api.reload('97335556', __exports__)
  }
  
  module.hot.accept("./HospitalMarketers.vue?vue&type=template&id=97335556", () => {
    console.log('re-render')
    api.rerender('97335556', render)
  })

}


export default __exports__